import React from 'react';
import Icon from 'flow/components/ui-components/Icon';
import IconButton from 'flow/components/ui-components/IconButton';
import Tooltip from 'flow/components/ui-components/Tooltip';

interface Props {
    label: string;
    onClick: (e: React.MouseEvent) => void;
    disabled: boolean;
    disabledTooltip?: string;
}

const IconButtonCreateTicket = ({
    label,
    onClick,
    disabled,
    disabledTooltip,
}: Props) => {
    if (disabled) {
        return (
            <Tooltip label={disabledTooltip}>
                <IconButton
                    disabled={true}
                    className="size-8 bg-gray-300 opacity-50"
                    aria-label={label}
                >
                    <Icon
                        iconKey="addNoteOutlined"
                        className="text-gray-400"
                        size="1.25rem"
                    />
                </IconButton>
            </Tooltip>
        );
    }

    return (
        <IconButton
            onClick={onClick}
            tooltipLabel={label}
            className="size-8 bg-gray-300"
            aria-label={label}
        >
            <Icon
                iconKey="addNoteOutlined"
                className="text-gray-600"
                size="1.25rem"
            />
        </IconButton>
    );
};

export default IconButtonCreateTicket;
